import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Switch } from '../ui/switch';

const API = `${process.env.REACT_APP_BACKEND_URL}/api/pas-admin`;

export const FeeWaiverSwitch = ({ client, token }) => {
  const [on, setOn] = useState(!!client.fee_waived);
  const [busy, setBusy] = useState(false);
  const toggle = async (v) => {
    setBusy(true);
    try {
      await axios.put(`${API}/clients/${client.client_id}/fee-waiver`, { waived: v }, { headers: { Authorization: `Bearer ${token}` } });
      setOn(v);
      toast.success(`${client.email}: transaction fee ${v ? 'waived' : 'restored'}`);
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Could not update fee waiver');
    } finally { setBusy(false); }
  };
  const owner = !!client.is_super_admin;
  return (
    <div className="flex items-center gap-2">
      <Switch checked={on || owner} disabled={busy || owner} onCheckedChange={toggle} data-testid={`admin-fee-waiver-switch-${client.client_id}`}
        className="data-[state=unchecked]:bg-slate-600" />
      <span className={`text-xs ${on || owner ? 'text-emerald-400' : 'text-slate-300'}`} data-testid={`admin-fee-waiver-label-${client.client_id}`}>{owner ? 'Owner · always waived' : on ? 'Waived' : '1% fee'}</span>
    </div>
  );
};
